module.exports = __webpack_public_path__ + "img/distributor-content-p1-content-img3.82ba8585.png";